// RC6.2 Slice 4 (B9) — shared, pure helpers for the cold-storage temperature-round UI.
// Kept framework-free so they are unit-testable in isolation.

export const UNIT_TYPE_LABELS = {
  fridge: "Fridge",
  freezer: "Freezer",
  display: "Display",
  blast_chiller: "Blast chiller",
  cold_room: "Cold room",
  other: "Other",
};

export const UNIT_TYPES = Object.keys(UNIT_TYPE_LABELS);

export const SKIP_REASONS = [
  { v: "out_of_service", l: "Out of service" },
  { v: "inaccessible", l: "Inaccessible" },
  { v: "equipment_problem", l: "Probe / equipment problem" },
  { v: "other", l: "Other (explain)" },
];

export const SKIP_LABELS = Object.fromEntries(SKIP_REASONS.map((r) => [r.v, r.l]));

export const unitTypeLabel = (t) => UNIT_TYPE_LABELS[t] || t;
export const skipReasonLabel = (r) => SKIP_LABELS[r] || r;

// True when a reading is outside the unit's configured range (a corrective-action comment is then
// mandatory). Mirrors the server-side pass/fail check exactly.
export function isOutOfRange(unit, temp) {
  if (temp === "" || temp == null || Number.isNaN(Number(temp))) return false;
  const t = Number(temp);
  if (unit?.minimum != null && t < unit.minimum) return true;
  if (unit?.maximum != null && t > unit.maximum) return true;
  return false;
}

// Progress of a round from its server-computed summary.
export function roundProgress(summary = {}) {
  return {
    done: (summary.recorded || 0) + (summary.skipped || 0),
    total: summary.expected || 0,
    outstanding: summary.outstanding ?? 0,
    canComplete: (summary.outstanding ?? 0) === 0,
  };
}

// Tailwind text tone for a completed round's outcome. A skipped unit is never "satisfactory".
export function roundOutcomeTone(outcome) {
  if (outcome === "satisfactory") return "text-brand-dark";
  if (outcome === "exception") return "text-red-600";
  return "text-amber-600";
}
